import { Button } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { ArrowReload } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { RetryErrorProps } from "./RetryError.types";

export const RetryError: FC<RetryErrorProps> = ({
  onRetry,
  "data-testid": dataTestId = "RetryError-container",
  title,
  text,
  onRetryButtonText,
  isSubmit,
}) => {
  const { t } = useCustomTranslation("common");

  return (
    <ErrorTemplate
      data-testid={dataTestId}
      text={text ?? t("errors.retry.text")}
      title={title ?? t("errors.retry.title")}
    >
      <Button
        data-testid="RetryError-retry"
        onClick={onRetry}
        startIcon={ArrowReload}
        type={isSubmit ? "submit" : "button"}
        variant="primary"
      >
        {onRetryButtonText ?? t("errors.retry.button")}
      </Button>
    </ErrorTemplate>
  );
};
